export default __webpack_public_path__ + "static/media/updated-payments-image-homepage.fa1cb19f.png";